import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZThemeModule } from '@knz/theme';

import { DownFileDirective } from './down-file.directive';

const DIRECTIVES = [DownFileDirective];

@NgModule({
  imports: [CommonModule, KNZThemeModule],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class DownFileModule {}
